import React, { useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from 'react-scale/components/design-system/styles';
import { LabelerStateHook } from 'react-scale/hooks/useLabelerState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';

const useStyles = makeStyles({
  substepRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 450,
    overflow: 'auto',
  },
  substepRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 4px',

    // Base values for text
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 500,
    '&.isCompleted': {
      opacity: 0.3,
    },
  },
  iconClickable: {
    cursor: 'pointer',
    fontSize: '16px',
    padding: '0 4px',
  },
  icon: {
    fontSize: '16px,',
    opacity: 0,
    padding: '0 8px',
    '&.isCompleted': {
      opacity: 1,
    },
  },
  iconClickableContainer: {
    display: 'flex',
    alignSelf: 'stretch',
    marginLeft: 'auto',
    marginRight: '6px',
  },
});

interface IAnnotationSubstepRowsProps {
  labelerStateHook: LabelerStateHook;
}

/**
 * Default ToolTip for GWFBar - Shows Current Step Name & Close Button
 */
const AnnotationSubstepRows: React.FC<IAnnotationSubstepRowsProps> = props => {
  const classes = useStyles();

  const { workflowState, setActiveStepId } = props.labelerStateHook.workflowHook;
  const { currentStep, completedStepIds } = workflowState;

  // Should never be null because we explicitly check before using this function
  const substeps = currentStep.steps;

  const handleIconClick = useCallback(
    (e: React.MouseEvent<Element, MouseEvent>, id: string) => {
      e.stopPropagation();
      setActiveStepId(id);
    },
    [setActiveStepId],
  );

  const defaultToolTip = (
    <>
      <div className={classes.substepRowContainer}>
        {_.map(substeps, (substep, index) => {
          const isCompleted = completedStepIds.includes(substep.id);

          return (
            <div className={classes.substepRow}>
              <div className={clsx(classes.icon, { isCompleted })}>
                <FontAwesomeIcon color="green" icon="check" />
              </div>
              {index + 1 + ': ' + substep.name}
              <div className={classes.iconClickableContainer}>
                <div
                  className={classes.iconClickable}
                  onClick={e => handleIconClick(e, substep.id)}
                >
                  <FontAwesomeIcon color="grey" icon="chevron-right" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  return <> {defaultToolTip}</>;
};

export default AnnotationSubstepRows;
